module.exports = __webpack_public_path__ + "img/main-link-bg.65de0446.png";